import { render, staticRenderFns } from "./userEdit.vue?vue&type=template&id=c06c4542"
import script from "./userEdit.vue?vue&type=script&lang=js"
export * from "./userEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c06c4542')) {
      api.createRecord('c06c4542', component.options)
    } else {
      api.reload('c06c4542', component.options)
    }
    module.hot.accept("./userEdit.vue?vue&type=template&id=c06c4542", function () {
      api.rerender('c06c4542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/userEdit.vue"
export default component.exports